import { getTokenFromCookies, url } from "../utils/configData";
// const url = `http://192.168.0.103:8000/api`;
const ExchangeRate = async (curr, coin, change = false, method = "null") => {
  const end = `/exchange/rates`;
  const token = getTokenFromCookies();

  const headers = {
    "Content-Type": "application/json",
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };
  try {
    const pair = change ? curr.toLowerCase() + ":" + coin.toLowerCase() : coin.toLowerCase() + ":" + curr.toLowerCase();

    const response = await fetch(url + end + `?pair=${pair}&method=${method}`, {
      method: "GET",
      credentials: "include",
      headers: headers,
    });
    if (response.ok) {
      const data = await response.json();
      return data;
      
    } else {
      return null;
    }
  } catch (error) {
    console.error("Failed to fetch user data:", error);
  }
};



const createChat = async ({
  buy_amount,
  buy_currency,
  buy_wallet,
  rate,
  sell_amount,
  sell_currency,
  sell_wallet,
  user,
}) => {
  const end = `/transactions/create`;
  const token = getTokenFromCookies();

  const headers = {
    "Content-Type": "application/json",
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };
  const body = JSON.stringify({
    buy_amount,
    buy_currency,
    buy_wallet,
    rate,
    sell_amount,
    sell_currency,
    sell_wallet,
    user
  });
  try {
    const response = await fetch(url + end, {
      method: "POST",
      credentials: "include",
      headers: headers,
      body: body,
    });
    if (response.ok) {
      return { success: true, status: response.status, message: "Transaction created successfully.", data: await response.json() };
    } else if (response.status === 403) {
      const data = await response.json();
      return { success: false, status: response.status, detail: data.detail };
    } else {
      return null;
    }
  } catch (error) {
    console.error("Failed to fetch user data:", error);
  }
};

export { ExchangeRate, createChat };
